import { createContext, useContext, useState, useEffect } from 'react';
import storeClient from '../api/storeClient';
import { applyBrandColor } from '../utils/brandColor';

const StoreSettingsContext = createContext({ contactEmail: null, contactPhone: null, contactSchedule: null, companyName: null });

export function StoreSettingsProvider({ children }) {
  const [settings, setSettings] = useState({ contactEmail: null, companyName: null });

  useEffect(() => {
    storeClient.get('/store/settings').then(({ data }) => {
      const s = data?.data ?? data ?? {};
      const brandColor = s.brand_color;
      const contactEmail = s.contact_email ?? null;
      const contactPhone = s.contact_phone ?? null;
      const contactSchedule = s.contact_schedule ?? null;
      const companyName = s.company_name ?? null;

      if (brandColor) {
        applyBrandColor(brandColor);
        localStorage.setItem('tenant-primary-color', brandColor);
      }

      setSettings({ contactEmail, contactPhone, contactSchedule, companyName });
    }).catch(() => {});
  }, []);

  return (
    <StoreSettingsContext.Provider value={settings}>
      {children}
    </StoreSettingsContext.Provider>
  );
}

export const useStoreSettings = () => useContext(StoreSettingsContext);
